import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { connect } from "react-redux";

const serviceData = [
  {
    image: "/icons/main/main_icon_1.png",
    title: "칼렛 기획전",
    description: "상시특가 & 시즌한정",
    url: "/products/Caret-Special/",
  },
  {
    image: "/icons/main/main_icon_2.png",
    title: "맞춤제작",
    description: "원하는 대로 제작가능",
    url: "/customizing/customizing-products/",
  },
  {
    image: "/icons/main/main_icon_3.png",
    title: "샘플구매",
    description: "사이즈,재질 체크",
    url: "/products/Sample-Purchase/",
  },
  {
    image: "/icons/main/main_icon_4.png",
    title: "스텝포넷제로",
    description: "친환경 한걸음",
    url: "/products/Step-For-Net-Zero/",
  },
  {
    image: "/icons/main/main_icon_5.png",
    title: "소량인쇄",
    description: "필요한 만큼만 인쇄",
    url: "/customizing/print/",
  },
  {
    image: "/icons/main/main_icon_6.png",
    title: "공동구매",
    description: "함께, 더 저렴하게",
    url: "/group-purchase/",
  },
  {
    image: "/icons/main/main_icon_7.png",
    title: "시제품제작",
    description: "빠른 초기 샘플",
    url: "/customizing/prototype/",
  },
  {
    image: "/icons/main/main_icon_8.png",
    title: "판촉물제작",
    description: "브랜드 홍보용",
    url: "/customizing/promotion/",
  },
  {
    image: "/icons/main/main_icon_9.png",
    title: "디자인서비스",
    description: "브랜딩/패키지 디자인",
    url: "/customizing/design-service/",
  },
];

// 카테고리 개별 구분

const CateogryMobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const CategoryMobile = styled.div`
  display: flex;
  justify-content: center;
`;

const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
`;

const CategoryListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const CategoryList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
`;

const CategoryBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  & figure {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    border-radius: 20px;
    background-color: #f4f4f4;
    padding: 8px;
    width: 115px;
    height: 115px;

    @media screen and (max-width: 991px) {
      width: 85px;
      height: 85px;
      padding: 4px;
    }

    @media screen and (max-width: 767px) {
      width: 65px;
      height: 65px;
      padding: 0px;
    }
  }

  & img {
    width: 100%;
  }

  &:hover span {
    color: #3bb77e;
  }
`;

const CategorySliderName = styled.span`
  width: 100%;
  text-align: center;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

const CategorySlider = ({ dummyList, siteConfig }) => {
  const router = useRouter();
  const [categoryType, setCategoryType] = useState("S");

  const [viewport, setViewport] = useState("pc"); // pc | tablet | mobile

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 767) setViewport("mobile");
      else if (width <= 991) setViewport("tablet");
      else setViewport("pc");
    };

    handleResize(); // 초기
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!dummyList?.category || !router.isReady) return;

    // slug가 있거나 경로가 /products/[ename]인 경우 ename 추출
    const enameFromUrl =
      router.query.slug || router.asPath.split("/products/")[1]?.split("/")[0];
    const matchedCategory = dummyList.category.find(
      (cat) => cat.ename === enameFromUrl
    );

    if (matchedCategory && matchedCategory.division) {
      setCategoryType(matchedCategory.division);
      localStorage.setItem("categoryType", matchedCategory.division);
    }
  }, [router.isReady, router.query.slug, dummyList?.category]);

  // 현재 선택된 카테고리 코드를 가져오는 함수
  const getCurrentCategoryCode = () => {
    if (router.query.code) {
      return router.query.code;
    }

    // URL이 /products/[slug] 형태인 경우 slug로 코드 찾기
    if (router.query.slug && dummyList?.category) {
      const matchedCategory = dummyList.category.find(
        (cat) => cat.ename === router.query.slug
      );
      if (matchedCategory) {
        return matchedCategory.code;
      }
    }

    return null;
  };

  // 현재 선택된 카테고리 코드
  const currentCategoryCode = getCurrentCategoryCode();

  // 공통으로 사용할 필터된 serviceData
  const filteredServiceData = serviceData.filter((item) => {
    const isPrototypeAvailable = siteConfig?.Prototype !== null;
    const isPromotionAvailable = siteConfig?.Promotion !== null;

    // 시제품제작 비활성화
    if (item.title === "시제품제작" && !isPrototypeAvailable) {
      return false;
    }

    // 판촉물제작 비활성화
    if (item.title === "판촉물제작" && !isPromotionAvailable) {
      return false;
    }

    // 디자인서비스는 두 조건이 모두 true일 경우 제외
    if (
      item.title === "디자인서비스" &&
      isPrototypeAvailable &&
      isPromotionAvailable
    ) {
      return false;
    }

    return true;
  });

  return (
    <>
      {/* 모바일/테블릿 */}
      {!router.pathname.includes("products") && viewport !== "pc" && (
        <CateogryMobileWrapper>
          <CategoryMobile>
            {viewport === "mobile" ? (
              // 모바일은 8개씩 페이징
              new Array(Math.ceil(filteredServiceData.length / 8))
                .fill("")
                .map((_, idx) => (
                  <div key={idx}>
                    <CategoryGrid>
                      {filteredServiceData
                        .slice(idx * 8, idx * 8 + 8)
                        .map((item, i) => (
                          <CategoryBox
                            key={i}
                            onClick={() => router.push(item.url)}
                          >
                            <figure>
                              <img
                                src={item.image}
                                alt={`${item.title}_이미지`}
                              />
                            </figure>
                            <h6>
                              <CategorySliderName>
                                {item.title}
                              </CategorySliderName>
                            </h6>
                          </CategoryBox>
                        ))}
                    </CategoryGrid>
                  </div>
                ))
            ) : (
              // 테블릿은 전체 한번에
              <CategoryGrid>
                {filteredServiceData.map((item, i) => (
                  <CategoryBox key={i} onClick={() => router.push(item.url)}>
                    <figure>
                      <img src={item.image} alt={`${item.title}_이미지`} />
                    </figure>
                    <h6>
                      <CategorySliderName>{item.title}</CategorySliderName>
                    </h6>
                  </CategoryBox>
                ))}
              </CategoryGrid>
            )}
          </CategoryMobile>
        </CateogryMobileWrapper>
      )}

      {/* PC */}
      {viewport === "pc" && (
        <CategoryListWrapper>
          <CategoryList>
            {filteredServiceData.map((item, i) => (
              <div key={i}>
                <CategoryBox onClick={() => router.push(item.url)}>
                  <figure>
                    <img src={item.image} alt={`${item.title}_이미지`} />
                  </figure>
                  <h6>
                    <CategorySliderName>{item.title}</CategorySliderName>
                  </h6>
                  <p className="font-sm">{item.description}</p>
                </CategoryBox>
              </div>
            ))}
          </CategoryList>
        </CategoryListWrapper>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
});

export default connect(mapStateToProps, null)(CategorySlider);
